import React from 'react';
import QRCode from 'qrcode.react';
import { DOWNLOAD_APP_DOMAIN, APP_NAME } from "utils/Config";
import i18n from "utils/I18n";
import { detectIsMobile } from 'utils';
import CustomButton from 'component/base/CustomButton';
import './NoWebappHappyDownloadPage.scss'
import { DownloadSectionWeb } from './NoWebappDownloadSection';

function DownloadPageMobile(props) {
    const isActionBar = props?.isActionBar
    const isMobile = detectIsMobile();
    if (!isMobile) {
        return null
    }
    return (
        <div className={`mobile-download-section`}>
            <label className='qrcode_message subheading'>
                {i18n.t("downloadAppToEarnReward")}
            </label>
            <CustomButton btnClicked={() => { window.open(DOWNLOAD_APP_DOMAIN) }} text={i18n.t("downloadApp")} className='download-btn-view' />
        </div>
    )
}

function DownloadPageWeb() {
    const isMobile = detectIsMobile();
    if (isMobile) {
        return null
    }
    return (
        <DownloadSectionWeb title={i18n.t("downloadAppToEarnReward")} />
    )
}

export default function NoWebappMemberAccountCompletePage() {
    const isMobile = detectIsMobile();

    return <div className="no-webapp-download">
        <div>
            <img
                className='success-tick'
                alt="success"
                src="/campaignDetail/SuccessTick.png"
                srcSet="/campaignDetail/SuccessTick@2x.png 2x, /campaignDetail/SuccessTick@3x.png 3x"
            />
        </div>

        <div className="qrcode_message subheading">
            {i18n.t("accountCompletedSuccess")}
        </div>
        {isMobile ? <DownloadPageMobile /> : <DownloadPageWeb />}
    </div>
}